import { render, staticRenderFns } from "./assessment-history.vue?vue&type=template&id=1e76ef40&scoped=true&lang=pug&"
import script from "./assessment-history.vue?vue&type=script&lang=ts&"
export * from "./assessment-history.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-history.vue?vue&type=style&index=0&id=1e76ef40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e76ef40",
  null
  
)

export default component.exports